if (!customElements.get('component-swiper')) {
  customElements.define(
    'component-swiper',
    class ComponentSwiper extends HTMLElement {
      constructor() {
        super();

        this.settings = JSON.parse(this.querySelector('script[type="application/json"]')?.innerHTML || '{}');
        this.swiperId = this.querySelector('.swiper')?.id;

      }

      connectedCallback() {
        if (!this.swiperId || this.swiper) return;

        // Starts when near the screen and the page is ready (see SliderLoader in global.js)
        window.SliderLoader.register(this, (Swiper) => this.init(Swiper), {
          target: this.querySelector('.swiper')
        });
      }

      disconnectedCallback() {
        window.SliderLoader.unregister(this);
      }

      init(Swiper) {
        if (this.swiper) return;
        this.swiper = new Swiper(this.querySelector(`[id="${this.swiperId}"]`), this.settings);
      }

    }
  )
}
